import { useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  IconButton,
  Collapse,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Facebook,
  Instagram,
  MailOutline,
  Phone,
  WhatsApp,
} from "@mui/icons-material";
import CustomText from "../components/CustomText";

const FrequentlyQuestions = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Grid container sx={design.Back} spacing={2}>
      <Grid size={design.Grid12}>
        <CustomText
          variant="subtitle1"
          color="#FFF"
          text="Preguntas frecuentes"
          sx={design.TextTitulo}
        >
          Preguntas frecuentes
        </CustomText>
      </Grid>

      <Grid size={design.Grid1} />
      <Grid size={design.Grid5}>
        {questions.map((q, index) => (
          <Card key={index} sx={design.Card}>
            <Box onClick={() => handleToggle(index)} sx={design.Box}>
              <CustomText
                variant="subtitle1"
                color="#FFF"
                text={q.title}
                sx={design.title}
              >
                {q.title}
              </CustomText>
              <IconButton
                sx={{
                  transform:
                    expandedIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                  ...design.Icon,
                }}
              >
                <ExpandMoreIcon />
              </IconButton>
            </Box>
            <Collapse in={expandedIndex === index} timeout="auto" unmountOnExit>
              <CardContent sx={design.Margin}>
                <CustomText
                  variant="subtitle1"
                  color="#FFF"
                  text={q.title}
                  sx={design.Description}
                >
                  {q.detail}
                </CustomText>
              </CardContent>
            </Collapse>
          </Card>
        ))}
      </Grid>
      <Grid size={design.Grid4} alignSelf="center">
        <Box style={design.CardR}>
          <CustomText
            variant="subtitle1"
            color="#333333"
            text="Síguenos en nuestras redes sociales"
            sx={design.TextRedes}
          >
            Síguenos en nuestras redes sociales
          </CustomText>
          <Grid container>
            {redesSociales.map((red, index) => (
              <IconButton
                key={index}
                sx={design.IconButton}
                onClick={() => {
                  window.open(
                    red.url,
                    red.url.startsWith("http") ? "_blank" : "_self",
                  );
                }}
              >
                {red.icon}
              </IconButton>
            ))}
          </Grid>
          <CustomText
            variant="subtitle1"
            color="#333333"
            text="Síguenos en nuestras redes sociales"
            sx={design.TextRedes}
          >
            Contáctanos también por WhatsApp
            <br />o a nuestros números telefónicos
          </CustomText>
          <Grid container sx={design.align}>
            <WhatsApp sx={design.IconColor} />
            <CustomText
              variant="subtitle1"
              color="#333333"
              text="Síguenos en nuestras redes sociales"
              sx={design.TextNum}
            >
              55 0000 0000
            </CustomText>
          </Grid>
          <Grid container sx={design.align}>
            <Phone sx={design.IconColor} />
            <CustomText
              variant="subtitle1"
              color="#333333"
              text="Síguenos en nuestras redes sociales"
              sx={design.TextNum}
            >
              +52 595 957 0961
            </CustomText>
          </Grid>
        </Box>
      </Grid>
      <Grid size={design.Grid1} />
    </Grid>
  );
};

export default FrequentlyQuestions;

const design = {
  TextTitulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 23,
      sm: 23,
      md: 35,
      lg: 35,
    },
    fontWeight: 700,
    textAlign: "center",
    mb: 1,
  },
  Back: {
    backgroundColor: "#2349D0",
    paddingTop: 4,
    paddingBottom: 4,
    px: 2,
  },
  TextRedes: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 18,
    lineHeight: "normal",
    fontWeight: 700,
    textAlign: "center",
  },
  TextNum: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 18,
    lineHeight: "normal",
    fontWeight: 400,
    textAlign: "center",
  },
  Card: {
    backgroundColor: "transparent",
    border: "2px solid #FFF",
    borderRadius: 4,
    mb: 2,
    color: "#FFF",
    overflow: "hidden",
    transition: "all 0.3s ease",
    width: "90%",
  },
  Box: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: 2,
    py: 1,
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
    lineHeight: "normal",
    marginTop: "2%",
    textAlign: "left",
  },
  IconButton: {
    fontSize: 40,
    color: "#2349D0",
    marginLeft: 3,
  },
  title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
    fontWeight: 500,
    textAlign: "left",
  },
  Icon: {
    transition: "transform 0.3s ease",
    color: "#FFF",
  },
  CardR: {
    width: "80%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    borderRadius: 15,
    boxShadow: "0 0 5px rgba(0,0,0,0.1)",
    padding: 25,
    backgroundColor: "#FFF",
  },
  align: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 2,
  },
  IconColor: { color: "#489E4D", fontSize: 35, marginRight: 5 },
  Margin: { pt: 0, px: 2, pb: 2 },
  Font: { fontSize: 35 },
  Grid1: { xs: 12, md: 1, xl: 1, lg: 1 },
  Grid5: { xs: 12, md: 5, xl: 5, lg: 5 },
  Grid4: { xs: 12, md: 4, xl: 4, lg: 4 },
  Grid12: { xs: 12, md: 12, xl: 12, lg: 12 },
};

const questions = [
  {
    title: "¿Cómo funciona el pre ingreso?",
    detail: "El pre ingreso permite agilizar el proceso antes de tu llegada.",
  },
  {
    title: "¿Mi aseguradora tiene convenio?",
    detail:
      "Trabajamos con múltiples aseguradoras reconocidas a nivel nacional.",
  },
  {
    title: "¿Puedo agendar una cita con un doctor en específico?",
    detail: "Sí, puedes seleccionar el médico que prefieras desde nuestra web.",
  },
  {
    title: "¿Cómo funcionan los servicios a domicilio?",
    detail: "Nuestros profesionales acuden a tu domicilio previa programación.",
  },
];

const redesSociales = [
  {
    icon: <Instagram sx={design.Font} />,
    url: "https://www.instagram.com/centromedico_medam?igsh=ajhiYnFmenJjMXBo",
    type: "instagram",
  },
  {
    icon: <Facebook sx={design.Font} />,
    url: "https://www.facebook.com/share/19EGRopCww/?mibextid=wwXIfr",
    type: "facebook",
  },
  {
    icon: <MailOutline sx={design.Font} />,
    url: "mailto:contacto@centromedicomedam.com",
    type: "mail",
  },
  // {
  //   icon: <X sx={design.Font} />,
  // },
  //   {
  //     icon:,
  //   },
  //   {
  //     icon: <Phone />,
  //   },
  //   {
  //     icon: <MailOutline />,
  //   },
];
